import { Helmet } from "react-helmet-async";
import { Reveal, Overline } from "../Reveal";
import { Link } from "react-router-dom";
import { FAQS } from "../../data/content";
import { SERVICE_AREA, REFUND_SUMMARY } from "../../data/pageFaqs";
import FaqList, { faqJsonLd } from "../FaqList";

// Homepage + pricing FAQ: the core questions plus where MagicBolt AI
// operates and its refund terms.
const ITEMS = [
  ...FAQS,
  { q: "Which countries do you serve?", a: SERVICE_AREA },
  { q: "Is there a refund or money-back guarantee?", a: REFUND_SUMMARY },
];
const FAQ_JSON_LD = faqJsonLd(ITEMS);

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 border-t border-[#E6E9F1] bg-white"
    >
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(FAQ_JSON_LD)}</script>
      </Helmet>
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-8">
        <Reveal className="max-w-2xl">
          <Overline>Questions, answered</Overline>
          <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tighter leading-none text-[#0B1533]">
            Frequently asked questions
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-12">
          <FaqList items={ITEMS} group="home-faq" testId="faq-accordion-item" />
        </Reveal>

        <Reveal delay={0.15} className="mt-8 text-center">
          <Link
            to="/faq"
            data-testid="view-all-faqs-link"
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#FF6B00] hover:gap-3 transition-all"
          >
            View all FAQs by product
            <span aria-hidden>→</span>
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
